import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import authGuard from '@/router/guards/auth-guard'
import LayoutFull from '@/layouts/full/LayoutFull.vue'
import PAGE_FEATURES from '@/constants/page-features'

export default [
  {
    path: '/store',
    component: LayoutFull,
    beforeEnter: multiGuard([checkTokenGuard, authGuard]),
    children: [
      {
        path: 'categories',
        name: 'owner:store-categories',
        pageFeatures: [PAGE_FEATURES.STORE],
        component: () => import(/* webpackChunkName: "store" */ '@/views/store/categories/CategoriesTable.vue'),
      },
      {
        path: 'products',
        name: 'owner:store-products',
        pageFeatures: [PAGE_FEATURES.STORE],
        component: () => import(/* webpackChunkName: "store" */ '@/views/store/products/ProductsTable.vue'),
      },
      {
        path: 'settings/:id',
        name: 'owner:store-settings',
        pageFeatures: [PAGE_FEATURES.STORE],
        component: () => import(/* webpackChunkName: "store" */ '@/views/store/settings/StoreSettings.vue'),
      },
      {
        path: 'products/process/:id?',
        name: 'owner:store-product',
        pageFeatures: [PAGE_FEATURES.STORE],
        component: () => import(/* webpackChunkName: "store" */ '@/views/store/settings/StoreSettings.vue'),
      },
    ],
  },
]
